import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  FormGroup,
  FormControl,
  ControlLabel,
  Checkbox,
} from "react-bootstrap";
import { Map } from "immutable";

export default class FormField extends Component {
  state = {
    inputValue: this.props.value || "",
  };

  componentDidUpdate(prevProps) {
    // Sync local state with prop value if it changes externally
    if (prevProps.value !== this.props.value) {
      this.setState({ inputValue: this.props.value || "" });
    }
  }

  onChange = function (event) {
    let value = this.inputEl.value;

    if (this.inputEl.type === "checkbox") {
      value = this.inputEl.checked;
      // Update checkbox directly, no local state needed
      clearTimeout(this._debounceTimer);
      this._debounceTimer = setTimeout(() => {
        this.props.onChange(this.props.configID, value, this.props.parent);
      }, this.props.debounceDelay || 300);
    } else {
      // Update local state for text inputs
      this.setState({ inputValue: value });
      clearTimeout(this._debounceTimer);
      this._debounceTimer = setTimeout(() => {
        this.props.onChange(this.props.configID, value, this.props.parent);
      }, this.props.debounceDelay || 300);
    }
  };

  render() {
    let fieldControl;
    switch (this.props.type) {
      case "checkbox":
        fieldControl = (
          <Checkbox
            name={this.props.configID}
            inputRef={(el) => (this.inputEl = el)}
            onChange={this.onChange.bind(this)}
            checked={this.props.value}
          >
            {this.props.label}
          </Checkbox>
        );
        break;
      case "textarea":
        fieldControl = (
          <FormControl
            componentClass="textarea"
            rows="5"
            name={this.props.configID}
            inputRef={(el) => (this.inputEl = el)}
            onChange={this.onChange.bind(this)}
            placeholder={this.props.placeholder}
            value={this.state.inputValue}
          />
        );
        break;
      case "select":
        fieldControl = (
          <FormControl
            name={this.props.configID}
            inputRef={(el) => (this.inputEl = el)}
            onChange={this.onChange.bind(this)}
            componentClass="select"
            placeholder="select"
            value={this.props.defaultSelected}
          >
            {this.props.defaultSelected ? null : (
              <option value="select">select</option>
            )}
            {this.props.options.map((option, i) => {
              let name = option;
              let value = option;

              if (Map.isMap(option)) {
                name = option.get("name");
                value = option.get("value");
              }

              return (
                <option key={i} value={value}>
                  {name}
                </option>
              );
            })}
          </FormControl>
        );
        break;
      default:
        fieldControl = (
          <FormControl
            name={this.props.configID}
            inputRef={(el) => (this.inputEl = el)}
            onChange={this.onChange.bind(this)}
            type={this.props.type}
            placeholder={this.props.placeholder}
            value={this.state.inputValue || this.props.defaultSelected}
          />
        );
        break;
    }

    return (
      <FormGroup>
        {this.props.type !== "checkbox" && (
          <ControlLabel>{this.props.label}</ControlLabel>
        )}
        {fieldControl}
      </FormGroup>
    );
  }
}

FormField.propTypes = {
  type: PropTypes.string.isRequired,
  configID: PropTypes.string.isRequired,
  parent: PropTypes.string,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  options: PropTypes.object,
  onChange: PropTypes.func,
  debounceDelay: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/components/FormField.js